<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>海關研學</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



    <div class="content">
      <div class="left-content">
        <div class="left-content-box">
          <el-menu
            mode="vertical"
            @select="handleSelect"
          >
            <el-menu-item class="left-tab" index="1"  @click="leftbtn(1)">
              <span>中心首頁</span>
            </el-menu-item>

            <el-menu-item class="left-tab" index="0"  @click="leftbtn(0)">
              <span>對比研究</span>
            </el-menu-item>
            
            <el-menu-item class="left-tab" index="2" @click="leftbtn(2)">
              <span>
                創作投稿
              </span>
              </el-menu-item>

            <el-menu-item class="left-tab1" index="3" @click="leftbtn(3)">
              <span>
                我的創作
              </span>
              </el-menu-item>

            <el-menu-item class="left-tab1" index="4" @click="leftbtn(4)">
              <span>
                投稿通道
              </span>
              </el-menu-item>
          </el-menu>
        </div>
        
      </div>

      <div class="right-content">

        <div class="search-select">
              <input 
              class="input"
                clearable
                placeholder="輸入關鍵詞搜索">
              <button class="search"></button>
              <div class="gjjs">
                <a href="#">高級檢索></a>
              </div>
        </div>

        <div class="row1">
          <div class="zjcz">
            <div class="area-title1">
              <div class="area-subtitle">最新創作</div>
              <div class="area-img"><img src="../assets/icon/line.png"></div>
              <div @click="more('new')" class="area-more"><a>更多></a></div>
            </div>

            
            <div v-for="(mycz,index) in czlist"  :key="index">
              <div v-if="index<3">

                <div class="cz-content">
                  <div @click="tocz(mycz.ID)"  class="cz-title">
                    <li><a class="lia" >{{mycz.proj_title}}</a></li>
                  </div>
                  <div class="cz-article">
                    <span>
                      {{mycz.proj_detail.slice(0,70)}}...
                    </span>
                  </div>
                </div>
              
              </div>
            </div>
            

            


          </div>

          <div class="zjyd">
            <div class="area-title2">
              <div class="area-subtitle">我的對比</div>
              <div class="area-img"><img src="../assets/icon/line.png"></div>
              <div @click="more('near')" class="area-more"><a>更多></a></div>
            </div>
            <div class="zjyd-box">

              <div v-for="(mycompare,index) in comparelist"  :key="index">
                <div v-if="index<6">

                  <div class="zjyd-row">
                    <div @click="tocompare(mycompare.comids)" class="zjyd-title">
                      {{mycompare.comparetitle.slice(0,20)}}

                    </div>
                    <div class="zjyd-time">
                      2020-01-02
                    </div>
                  </div>
                
                </div>
              </div>

              

            </div>
          </div>
        </div>


        <div class="row2">
          <div class="wdsc">
            <div class="area-title1">
              <div class="area-subtitle">我的收藏</div>
              <div class="area-img"><img src="../assets/icon/line.png"></div>
              <div @click="more('my')" class="area-more">更多></div>
            </div>

            <div class="first-sc-box">
              <div class="img-box">
                <img>
              </div>
              <div class="fist-sc">
                <div @click="tosc(0)" class="sc-title">
                  旧海关史料与煤油进口（1863-1904）
                </div>
                <div class="sc-content">
                  中国海关出版物评述中国海关出版物评述中国海关出版物评述中国海关出中国海关出版物评述中国海关出版物评述中国海关出版物评述中国海关出版物评述
                </div>
              </div>
            </div>

            <div class="sc-container">

              <div v-for="(mysc,index) in sclist"  :key="index">
                <div v-if="index<3">

                  <div class="sc-box">
                    <div @click="tosc(0)" class="wdsc-title">中国海关出版物评述-《哈佛燕京大学》</div>
                    <div class="wdsc-time">2020-01-02</div>
                  </div>
                
                </div>
              </div>

            </div>

          </div>

          <div class="ltxfb">
            <div class="area-title2">
              <div class="area-subtitle">論壇新發布</div>
              <div class="area-img"><img src="../assets/icon/line.png"></div>
              <div @click="more('lt')" class="area-more">更多></div>
            </div>

            <div class="ltfb-box">


              

              <div v-for="(mytalk,index) in talklist"  :key="index">
                <div v-if="index<6">

                  <div class="ltfb-row">
                    <div @click="totalk(mytalk.ID)" class="ltfb-title">
                      {{mytalk.talktitle}}
                    </div>
                    <div class="ltfb-time">
                      {{mytalk.talktime}}
                    </div>
                  </div>
                
                </div>
              </div>


              

            </div>

          </div>
        </div>

      </div>
      


        
    </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
      //totaldata:'99999',
      activeIndex:1,
      talklist:[],
      sclist:[],
      dblist:[],
      czlist:[],
      id:0,
    };
  },
  created() {
      //获取论坛列表gettalklist(int id,string searchinfo)
      this.$http
        .get(`${this.$store.state.baseurl}/api/hgtalk/gettalklist?id=`+this.id+"&searchinfo=''")
        .then((res) => {
          const json = res.data;
          this.talklist = JSON.parse(json).data;

          //console.log("talklist:"+this.talklist)
          
        });
      //获取收藏列表


      //获取对比列表
      this.$http
        .get(`${this.$store.state.baseurl}/api/hgresearch_compare/getcomparelist?username=1`+"&userid='2'")
        .then((res) => {
          const json = res.data;
          this.comparelist = JSON.parse(json).data;
          //console.log("comparelist:"+this.comparelist)
          
          
        });

      ///获取创作列表
      this.$http
      .get(`${this.$store.state.baseurl}/api/hgsub/getsublist`)
      .then((res) => {
        let json=JSON.parse(res.data);
        this.czlist=json.data;
        //console.log("czlist:"+this.czlist);
      });


  },
  methods: {
   

    tocz(cid){
      //跳转创作
      this.$router.push({ path: "/hgresearch_new",query:{id:cid}});
    },
    tocompare(cid){
      //跳转到对比详情
      this.$router.push({ path: "/hgresearch_compare",query:{ids:cid}});
    },
    tosc(cid){
      //跳转到收藏详情
      this.$router.push({ path: "/hgsub_detail",query:{id:cid}});
    },
    totalk(cid){
      //跳转到论坛详情
      this.$router.push({ path: "/hgtalk_detail",query:{id:cid}});
    },
    //点击更多
    more(tab){
      if(tab=='new'){
        //最新创作
        this.$router.push({ path: "/hgresearch_list_cz",query:{tab:'new'}});
       
      }
      if(tab=='near'){
        //对比研究
        this.$router.push({ path: "/hgresearch_list_compare",query:{tab:'near'}});

      }
      if(tab=='my'){
        //我的收藏
        this.$router.push({ path: "/hgresearch_list_sc",query:{tab:'my'}});

      }
      if(tab=='lt'){
        //论坛
        this.$router.push({ path: "/hgresearch_list_talk",query:{tab:'lt'}});

      }
    },
    
    leftbtn(a){
      this.activeIndex=a; 
      if(this.activeIndex==0){
        //对比

      }
      if(this.activeIndex>1){
        //创作
        this.$router.push({ path: "/hgresearch_cz",query:{aIndex:this.activeIndex}});
      }
    },
  },
};
</script>


<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .left-content{
    width:180px;
    min-height:600px;
    font-size: 16px;
    border-width: 0px 1px 0px 0px ;
	  border-style: solid;
	  border-color:#cec0b2;
    .left-content-box{
        margin-top: 16px;
        .left-tab{
          border-width: 0px 1px 0px 0px ;
          font-weight: 550;
          text-align: left;
          background: none;
          font-size: 16px;
          width: 100%;
          word-break: break-all !important;
          white-space: break-spaces !important; 
          span{
            white-space: nowrap !important;
          }
        }


        .left-tab1 :hover{
          background-color:#e5e2db !important ;
          color: #666666;
          font-weight: 400;
          font-size: 14px;

        }
        .left-tab1{
          
          border-width: 0px 1px 0px 0px ;
          font-weight: 400;
          text-align: center;
          background: none;
          font-size: 14px;
          width: 100%;
          word-break: break-all !important;
          white-space: break-spaces !important; 
          span{
            white-space: nowrap !important;
          }
        }
      

    }
    
  }
  .right-content{
    width: 1000px;
  }
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.search-select {
  display: flex;
  justify-content: center;
  padding-top: 30px;
  .input {
    border-radius: 5px;
    width: 600px;
    height: 45px;
    padding-left: 20px;
    font-size: 14px;
    color: #999999;
    border: 0px;
  }
  .search {
    border-radius:5px;
    width: 100px;
    height: 45px;
    background: url("../assets/image/search.png") no-repeat;
    background-size:102px 45px;
    border-style: none;

  }
  .gjjs{
    font-size: 14px;
    padding-top: 15px;
    margin-left: 20px;
  }
  .gjjs a{
    text-decoration: none;
    color: #000;
  }
}

.row1{
  padding-top: 20px;
  padding-bottom: 20px;
  width:1000px;
  height: 350px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .zjcz{
    padding:5px 20px 20px 20px;
    width: 560px;
    height: 325px;
    .cz-content{
      text-align: left;
      padding: 15px 0px 15px 0px;
      border-width: 0px 0px 1px 0px ;
      border-style: dashed;
      border-color:#cec0b2;
      .cz-title{
        color: #333333;
        font-size: 14px;
        font-weight: 600;
        li .lia{
          text-decoration: none;
          color: #333333;
          cursor:pointer;
        }
      }
      .cz-article{
        padding: 10px 15px 5px 15px;
        color: #666666;
        font-size: 14px;
        line-height:20px;
      }
    }
    
  }
  .zjyd{
    padding:5px 20px 20px 20px;
    width: 360px;
    height: 325px;
    .zjyd-box{
      font-size: 14px;
      color: #333333;
      text-align: left;
      padding: 15px 0px 15px 0px;
      .zjyd-row{
        margin-top: 15px;
        margin-bottom: 25px;
        display: flex;
        flex-direction: row;
        justify-content: start;
      flex-wrap: wrap;
        .zjyd-title{
          width: 280px;
          cursor: pointer;
        
          

        }
        .zjyd-time{
          width: 80px;
        }
      }
    }


  }
  
}
.row2{
  padding-top: 20px;
  padding-bottom: 20px;
  width:1000px;
  height: 350px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .wdsc{
    padding:5px 20px 20px 20px;
    width: 560px;
    height: 325px;
    .first-sc-box{
      margin:10px 10px 10px 10px;
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      .img-box{
        width:150px;
        height: 150px;
        img{
          width: 130px;
          height:130px;
          padding: 10px 20px 10px 0px;
        }

      }
      .fist-sc{
        display: flex;
        flex-direction: row;
        justify-content: start;
        flex-wrap: wrap;
        width: 390px;
        height: 150px;
        font:14px;
        .sc-title{
          cursor: pointer;
          margin: 12px 0px 0px 0px;
          color: #333333;
          text-align: left;
          font-weight: 500;
        }
        .sc-content{
          color: #666666;
          text-align: left;
        }
      }
    }
    .sc-container{
      
      .sc-box{
        display: flex;
        flex-direction: row;
        justify-content: start;
        flex-wrap: wrap;
        font-size: 14px;
        color: #333333;
        margin:25px 15px 25px 15px ;
        .wdsc-title{
          cursor: pointer;
          width:430px;
          text-align: left;

        }
        .wdsc-time{
          width: 100px;
          text-align: right;

        }
      }
    }
  }
  .ltxfb{
    padding:5px 20px 20px 20px;
    width: 360px;
    height: 325px;

    .ltfb-box{
      font-size: 14px;
      color: #333333;
      text-align: left;
      padding: 15px 0px 15px 0px;
      .ltfb-row{
        margin-top: 15px;
        margin-bottom: 30px;
        display: flex;
        flex-direction: row;
        justify-content: start;
      flex-wrap: wrap;
        .ltfb-title{
          width: 280px;
          cursor: pointer;
        }
        .ltfb-time{
          width: 80px;
        }
      }
    }



  }
}

.area-title1{
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .area-subtitle{
    width: 100px;
    text-align: left;
    font-size: 20px;
    color: #906442;
  }
  .area-img{
    width:410px;
    padding-top: 12px;
    text-align: left !important;
  }
  .area-more{
    cursor: pointer;
    text-align: right;
    padding-top: 10px;
    color: #9d795e;
    font-size: 12px;
    width: 50px;
    a{
      text-decoration: none;
      color:#9d795e;
    }
  }

}

.area-title2{
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .area-subtitle{
    width: 100px;
    text-align: left;
    font-size: 20px;
    color: #906442;
  }
  .area-img{
    width:210px;
    padding-top: 12px;
    img{
      width:210px;
    }
  }
  .area-more{
    cursor: pointer;
    padding-top: 10px;
    text-align: right;
    color: #9d795e;
    font-size: 12px;
    width: 40px;
    a{
      color: #9d795e;
      text-decoration: none;
    }
  }

}



</style>